import { render, staticRenderFns } from "./CurationCard.vue?vue&type=template&id=5ba84ed0&scoped=true&"
import script from "./CurationCard.vue?vue&type=script&lang=ts&"
export * from "./CurationCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=5ba84ed0&prod&scoped=true&lang=css&"
import style1 from "./CurationCard.vue?vue&type=style&index=1&id=5ba84ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba84ed0",
  null
  
)

export default component.exports